module.exports = __webpack_public_path__ + "img/txtm.a22fbfd2.png";